import { render } from "./AgendaTreinos.vue?vue&type=template&id=645f0325&scoped=true"
import script from "./AgendaTreinos.vue?vue&type=script&lang=js"
export * from "./AgendaTreinos.vue?vue&type=script&lang=js"

import "./AgendaTreinos.vue?vue&type=style&index=0&id=645f0325&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645f0325"]])

export default __exports__